var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ViewHeader',{attrs:{"account-id":_vm.accountId,"project-id":_vm.projectId}}),_c('div',{staticClass:"p-8"},[_c('div',{staticClass:"max-w-7xl mx-auto"},[_c('SmsCampaignList',{attrs:{"account-id":_vm.accountId,"project-id":_vm.projectId}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }